import { render, staticRenderFns } from "./DashTip.vue?vue&type=template&id=45c56c99&"
import script from "./DashTip.vue?vue&type=script&lang=js&"
export * from "./DashTip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports